module.exports = __webpack_public_path__ + "img/samoa.42a494f8.svg";